import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class CanActivateSuperAdminSettingsGuard implements CanActivate {
    constructor(
        private commonDataService: CommonDataService,
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(): Observable<boolean> {
        const community = this.authenticationService.community;
        if (this.commonDataService.user.constraints?.isExtendedAccessEnabled) {
            return of(true);
        }

        this.router.navigate([`/${community}/403`], { skipLocationChange: true });
        return of(false);
    }
}
